import AutoFormGroup from '@shared/components/forms/auto-form/auto-form-group/auto-form-group.vue';
import { FormConfig, FormFieldConfig } from '@shared/interfaces/config';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-entity-export-options-form',
  components: {
    'bpc-auto-form-group': AutoFormGroup,
  },
})
export default class EntityExportOptionsForm extends Vue {
  @Prop(String) readonly entityType: string;
  @Prop(String) readonly configPath: string;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: object;
  @Prop(Boolean) readonly disabled: boolean;
  @Prop(String) readonly disableTag: string;
  @Prop(Object) readonly errors: object;
  @Prop([Number, String]) entityId: number | string;

  get formModel(): object {
    return this.value || {};
  }

  set formModel(value) {
    this.$emit('input', value);
  }

  public config = {};
  public loading = true;
  public exportOptions: Record<string, string[]> = null;
  public allOptionFormsObject: Record<string, Record<string, FormFieldConfig>> = {};

  public get allOptionFields(): Record<string, FormFieldConfig[]> {
    return Object.keys(this.allOptionFormsObject).reduce((result, targetEntityName) => {
      result[targetEntityName] = Object.values(this.allOptionFormsObject[targetEntityName]);
      return result;
    }, {});
  }

  async mounted() {
    await this.setEntityExportOptionsConfig();
  }

  async setEntityExportOptionsConfig() {
    this.loading = true;
    this.exportOptions = await this.getEntityOptionsConfig();
    // To be sure that this is an object
    this.exportOptions = this.exportOptions || {};

    this.allOptionFormsObject = await this.getAllOptionFormConfig();
    this.setFormModelKeys();
    this.loading = false;

    return this.allOptionFormsObject;
  }

  setFormModelKeys(): void {
    const newFormModel = {};

    Object.keys(this.exportOptions).forEach(targetEntityName => {
      this.$set(newFormModel, targetEntityName, {});
      newFormModel[targetEntityName] = this.$bpcModelFactory.getInitialFormModel(
        this.allOptionFormsObject[targetEntityName],
        null,
        this.formModel[targetEntityName] || newFormModel[targetEntityName],
      );
    });

    this.formModel = newFormModel;
  }

  async getAllOptionFormConfig(): Promise<Record<string, Record<string, FormFieldConfig>>> {
    const targetEntities = Object.keys(this.exportOptions);
    const allFormPromises = await this.getAllFormPromises(targetEntities);
    const resolvedFormPromises = await Promise.all(allFormPromises);
    return this.formatAllOptionForms(targetEntities, resolvedFormPromises);
  }

  async getEntityOptionsConfig() {
    const { data } = await this.$bpcConfig
      .getEntityConfig(`${this.entityType}.options.export`)
      .toPromise();

    return data;
  }

  async getAllFormPromises(targetEntities: string[]) {
    return targetEntities.reduce((allPromises, targetEntityName) => {
      const promise = this.$bpcConfig
        .getEntityConfig(`${this.entityType}.forms.options_export__${targetEntityName}`)
        .toPromise();

      allPromises.push(promise);
      return allPromises;
    }, []);
  }

  formatAllOptionForms(
    targetEntities: string[],
    forms: { data: FormConfig }[],
  ): Record<string, Record<string, FormFieldConfig>> {
    return forms.reduce((result, currentForm, index) => {
      const fieldsConfigObject = currentForm.data?.fields || {};
      this.$set(result, targetEntities[index], fieldsConfigObject);
      return result;
    }, {});
  }

  onFieldChange(field, value) {
    this.$emit('field-change', field, value);
  }
}
